import classnames from 'classnames/bind';
import { FC, memo, ReactNode } from 'react';
import styles from './SplitPane.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  containerClassName?: string;
  leftPaneClassName?: string;
  rightPaneClassName?: string;

  leftPaneContent: ReactNode;
  rightPaneContent: ReactNode;
};

export const SplitPane: FC<Props> = memo(
  ({
    containerClassName,
    leftPaneContent,
    leftPaneClassName,
    rightPaneContent,
    rightPaneClassName,
  }) => {
    return (
      <div className={cx(styles['container'], containerClassName)}>
        <div className={cx(styles['left-pane'], leftPaneClassName)}>
          {leftPaneContent}
        </div>
        <div className={cx(styles['right-pane'], rightPaneClassName)}>
          {rightPaneContent}
        </div>
      </div>
    );
  }
);
SplitPane.displayName = 'SplitPane';
